// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-to-clipboard-text.plain[data-v-700553c8]{color:var(--body-text)}.copy-to-clipboard-text.plain[data-v-700553c8]:hover{text-decoration:none}.copy-to-clipboard-text.copied[data-v-700553c8]{pointer-events:none;color:var(--success)}", ""]);
// Exports
module.exports = exports;
